<script lang="ts">
	//UI
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import KakaoChannelStatus from "@hitit/mbr/src/v7/component/Point/KakaoChannelStatus.svelte";
	import KakaoAlarmTemplate from "../component/Point/KakaoAlarmTemplate.svelte";
	import PointInfomation from "../component/Point/PointInfomation.svelte";
	//Utils
	import { api, notifications } from "@hitit/hub/src/stores";
	//Types
	import type { PointTemplateDTO } from "@hitit/api/src/types";
	import { onDestroy } from "svelte";
	import { popup } from "@hitit/hub/src/v7/store";
	//Props
	export let storeId = "";
	//Constants
	//Variables
	let loading = false;
	let value = "";
	let kakaoChannelLoading = false;
	let kekaoTemplateLoading = false;

	let pointInfos: {
		pointRewardable: boolean;
		pointRewardPercent: number;
		pointExpirationInDays: string;
		categories: { name: string; rewardable: boolean }[];
	};

	let channelSetting: {
		channelId: string;
		channelName: string;
		channelStatus: string;
		useSmsFailover: boolean;
	};

	let template: {
		channelId: string;
		content: string;
		id: string;
		templateCode: string;
		templateInspectionStatus: string;
		templateName: string;
		templateStatus: string;
		templateType: string;
	}[] = [];

	//Functions
	async function getStorePointInfos(storeId: string) {
		try {
			loading = true;

			const [
				categoryResponse,
				pointSettingResponse,
				pointChannelResponse,
				pointChannerTemplateResponse,
			] = await Promise.all([
				$api.getStoreItems(storeId),
				$api.getPointSetting(storeId),
				$api.getPointChannelSetting(storeId),
				$api.getPointChannelTemplate(storeId),
			]);

			const { categoryDTOs } = categoryResponse.data;
			const { setting } = pointSettingResponse.data;
			const parseExpiration = (day: number) => {
				if (day < 365 && 30 < day) {
					return `${Math.floor(day / 30)}개월`;
				} else if (day >= 365) {
					return `${Math.floor(day / 365)}년`;
				} else {
					return `${day}일`;
				}
			};
			const templateDTOs = qcTemplateDTOMigration(
				pointChannerTemplateResponse.data
			);
			const channelSettingDTOs = pointChannelResponse.data || {
				channelId: "",
				channelName: "",
				channelStatus: "포인트 설정이 없습니다",
				useSmsFailover: false,
			};
			pointInfos = {
				pointRewardable: setting.pointType === "POINT" ? true : false,
				pointRewardPercent: setting.pointTypeSettingDTO?.rewardPercent || 0,
				pointExpirationInDays: setting.pointTypeSettingDTO?.expirationInDays
					? parseExpiration(setting.pointTypeSettingDTO?.expirationInDays)
					: "-",
				categories: categoryDTOs.map((v) => ({
					name: v.translationDTOs[0].name,
					rewardable: v.rewardable,
				})),
			};
			channelSetting = channelSettingDTOs;
			template = templateDTOs;
			value = pointChannelResponse.data.channelId;
		} catch (e) {
			console.log(e);
		} finally {
			loading = false;
		}
	}

	function qcTemplateDTOMigration(templates: PointTemplateDTO[]) {
		return templates.map((v) => {
			return {
				channelId: v.channelId,
				content: v.content.replaceAll("\n", "</br>"),
				id: v.id,
				templateCode: v.templateCode,
				templateInspectionStatus: v.templateInspectionStatus,
				templateName: v.templateName,
				templateStatus: v.templateStatus,
				templateType: v.templateType,
			};
		});
	}

	async function getChannelStatus() {
		try {
			kakaoChannelLoading = true;
			const response = await $api.getPointChannelSetting(storeId);
			const settingDTO = response.data || {
				channelId: "",
				channelName: "",
				channelStatus: "포인트 설정이 없습니다",
				useSmsFailover: false,
			};
			channelSetting = settingDTO;
			value = response.data.channelId || "";
		} catch (e) {
			console.log(e);
		} finally {
			kakaoChannelLoading = false;
		}
	}

	async function getTemplateQCStatus() {
		try {
			kekaoTemplateLoading = true;
			const response = await $api.getPointChannelTemplate(storeId);
			const settingDTO = qcTemplateDTOMigration(response.data);
			template = settingDTO;
		} catch (e) {
			console.log(e);
		} finally {
			kekaoTemplateLoading = false;
		}
	}

	async function channelIdChange(event: { detail: { id: string } }) {
		try {
			kakaoChannelLoading = true;
			const { data } = await $api.postPointChannelSetting(
				storeId,
				event.detail.id,
				template
			);
			await getChannelStatus();

			data.status === "OK"
				? notifications.append(
						"SUCCESS",
						data.message,
						"",
						undefined,
						"SUCCESS"
				  )
				: notifications.append("ERROR", data.message, "", undefined, "WARNING");
		} catch {
			value = channelSetting.channelId || "";
			notifications.append(
				"ERROR",
				"WrongFormatError",
				"",
				undefined,
				"WARNING"
			);
		} finally {
			kakaoChannelLoading = false;
		}
	}

	//Do
	$: getStorePointInfos(storeId);
	onDestroy(() => {
		$popup = undefined;
	});

</script>

<div class="container">
	{#if loading}
		<ContainerLoading />
	{:else}
		<div class="point-infomation">
			<PointInfomation
				categories={pointInfos.categories}
				expirationInDays={pointInfos.pointExpirationInDays}
				rewardable={pointInfos.pointRewardable}
				rewardRatio={pointInfos.pointRewardPercent} />
		</div>
		<div class="kakaoChanelStatus">
			<KakaoChannelStatus
				isLoading={kakaoChannelLoading}
				channelStatus={channelSetting}
				value={value}
				on:channelRefresh={getChannelStatus}
				on:channelIdChange={channelIdChange} />
		</div>
		<div class="template">
			<KakaoAlarmTemplate
				isLoading={kekaoTemplateLoading}
				templateDTOs={template}
				on:kakaoTemplateRefresh={getTemplateQCStatus} />
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			flex-wrap: wrap;
			gap: 30px;

			.kakaoChanelStatus,
			.point-infomation {
				flex-basis: calc(50% - 15px);
			}
			.template {
				flex-basis: 100%;
			}
		}
	}

</style>
